<template>
  <li
    class="blog-card mx-auto max-w-[360px] overflow-hidden rounded-lg bg-white shadow-[0px_0px_35px_rgba(0,0,0,0.08)] not-first:mt-9"
    itemscope
    itemtype="http://schema.org/BlogPosting"
  >
    <NuxtLink class="block" :to="localePath(`/blog/${link}`)">
      <NuxtImg
        class="h-[200px] w-full object-cover"
        :src="imgMain"
        :alt="title"
        width="301"
        height="200"
        format="webp"
        :placeholder="getBlogPlaceholderForKey(imgMain)"
        itemprop="image"
      />
      <div class="blog-card-content px-[22px] py-4">
        <ul v-if="tagObj" class="mb-4">
          <li
            :key="tagObj.id"
            class="inline-block rounded bg-[#f2f2f2] px-2.5 py-1 text-[0.575rem] leading-normal text-[#666]"
            itemprop="keywords"
          >
            {{ tagObj.name }}
          </li>
        </ul>
        <h3
          class="blog-card-title mb-6 text-base font-semibold leading-[1.375] text-black"
          itemprop="headline"
        >
          {{ title }}
        </h3>
        <div
          class="author-wrap flex items-center border-t border-[#f4f7f6] pt-2"
          itemprop="author"
          itemscope
          itemtype="http://schema.org/Person"
        >
          <NuxtImg
            class="author-img mr-3 h-9 w-9 shrink-0 rounded-full object-cover"
            :src="authorImg"
            :alt="authorName"
            width="37"
            height="37"
            format="webp"
            :placeholder="getBlogPlaceholderForKey(authorImg)"
            itemprop="image"
          />
          <p class="author-name m-0 text-[0.625rem] uppercase leading-[1.9] text-[#666]">
            by <strong itemprop="name">{{ authorName }}</strong>
          </p>
        </div>
      </div>
    </NuxtLink>
  </li>
</template>

<script setup lang="ts">
import type { BlogCategory } from "~/slices/blog/types";
import { getBlogPlaceholderForKey } from "~/shared/composables/useBlogPlaceholder";

defineProps<{
  imgMain: string;
  title: string;
  authorImg: string;
  authorName: string;
  tagObj: BlogCategory | null;
  link: string;
}>();

const localePath = useLocalePath();
</script>

<style scoped>
@media (min-width: 768px) {
  .blog-card {
    @apply mx-0;
  }
  .blog-card:not(:last-of-type) {
    @apply mb-0;
  }
}
</style>
